import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Custom hook to extract the current page number from URL query parameters
 * @returns {number} The current page number (defaults to 1 if not found)
 */
const usePageFromURL = () => {
    const location = useLocation();

    const page = useMemo(() => {
        const searchParams = new URLSearchParams(location.search);
        const pageParam = searchParams.get('page');
        return pageParam ? parseInt(pageParam, 10) || 1 : 1;
    }, [location.search]);

    return page;
};

export default usePageFromURL;
